
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shared-project/[projectId]/overview",
      function () {
        return require("private-next-pages/shared-project/[projectId]/overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shared-project/[projectId]/overview"])
      });
    }
  